import React from 'react';
import { useScrollProgress } from '../../hooks/useScrollProgress';
import './ScrollProgress.css';

const ScrollProgress = () => {
  const progress = useScrollProgress();

  return (
    <div className="scroll-progress-track" aria-hidden="true">
      <div
        className="scroll-progress-bar"
        style={{ transform: `scaleX(${progress})` }}
      />
    </div>
  );
};

export default ScrollProgress;
